import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Instagram, Facebook, Twitter, Droplet, Leaf, Truck, Zap, ArrowLeft, Star } from 'lucide-react';
import { toast } from 'sonner';
const NAV_LINKS = [{
  name: 'התפריט',
  href: '#menu'
}, {
  name: 'מנויים',
  href: '#subscriptions'
}, {
  name: 'חנויות',
  href: '#stores'
}, {
  name: 'עלינו',
  href: '#about'
}];
const FLAVORS = [{
  name: 'פצצת אנרגיה',
  ingredients: "תפוז, גזר, ג'ינג'ר, כורכום",
  price: '₪24',
  color: 'bg-[#ff7a00]',
  shadow: 'shadow-[#ff7a00]/50',
  emoji: '🍊'
}, {
  name: 'ירוק עד',
  ingredients: 'תפוח, סלרי, תרד, לימון',
  price: '₪26',
  color: 'bg-[#aaff00]',
  shadow: 'shadow-[#aaff00]/50',
  emoji: '🍏'
}, {
  name: 'ברי בלאסט',
  ingredients: 'אוכמניות, תות, בננה, אסאי',
  price: '₪28',
  color: 'bg-[#8b3dff]',
  shadow: 'shadow-[#8b3dff]/50',
  emoji: '🫐'
}, {
  name: 'סאנשיין',
  ingredients: 'אננס, מנגו, פסיפלורה',
  price: '₪26',
  color: 'bg-[#ffd23f]',
  shadow: 'shadow-[#ffd23f]/50',
  emoji: '🍍'
}, {
  name: 'פינק פלמינגו',
  ingredients: 'סלק, תפוח, גזר, לימון',
  price: '₪24',
  color: 'bg-[#ff3da6]',
  shadow: 'shadow-[#ff3da6]/50',
  emoji: '🦩'
}, {
  name: 'אקווה בלו',
  ingredients: 'ספירולינה, קוקוס, אננס',
  price: '₪28',
  color: 'bg-[#00d4ff]',
  shadow: 'shadow-[#00d4ff]/50',
  emoji: '🥥'
}];
const PLANS = [{
  name: 'יומי',
  desc: 'בקבוק אחד כל בוקר',
  price: '₪499',
  period: 'לחודש',
  color: 'bg-[#00d4ff]',
  popular: false
}, {
  name: 'שבועי',
  desc: 'מארז 6 בקבוקים בסופ"ש',
  price: '₪399',
  period: 'לחודש',
  color: 'bg-[#ff3da6]',
  popular: true
}, {
  name: 'חודשי',
  desc: 'מארז 24 בקבוקים פעם בחודש',
  price: '₪299',
  period: 'לחודש',
  color: 'bg-[#ff7a00]',
  popular: false
}];
const BENEFITS = [{
  title: '100% טבעי',
  icon: Leaf,
  color: 'text-[#aaff00]',
  bg: 'bg-[#aaff00]/20'
}, {
  title: 'ללא סוכר מוסף',
  icon: Droplet,
  color: 'text-[#00d4ff]',
  bg: 'bg-[#00d4ff]/20'
}, {
  title: 'סחיטה קרה',
  icon: Zap,
  color: 'text-[#ff7a00]',
  bg: 'bg-[#ff7a00]/20'
}, {
  title: 'משלוח עד הבית',
  icon: Truck,
  color: 'text-[#8b3dff]',
  bg: 'bg-[#8b3dff]/20'
}];
const GALLERY = [{
  caption: 'בוקר של אלופים',
  emoji: '🍊',
  gradient: 'bg-gradient-to-br from-[#ff7a00] to-[#ffd23f]',
  span: 'col-span-2 row-span-2'
}, {
  caption: 'ירוק ובריא',
  emoji: '🥝',
  gradient: 'bg-gradient-to-br from-[#aaff00] to-[#00d4ff]',
  span: 'col-span-1 row-span-1'
}, {
  caption: 'מתוק ורוד',
  emoji: '🍓',
  gradient: 'bg-gradient-to-br from-[#ff3da6] to-[#8b3dff]',
  span: 'col-span-1 row-span-1'
}, {
  caption: 'טרופי בקיץ',
  emoji: '🍍',
  gradient: 'bg-gradient-to-br from-[#ffd23f] to-[#ff3da6]',
  span: 'col-span-2 row-span-1'
}, {
  caption: 'גלי ים',
  emoji: '🥥',
  gradient: 'bg-gradient-to-br from-[#00d4ff] to-[#8b3dff]',
  span: 'col-span-1 row-span-1'
}, {
  caption: 'פיצוץ סגול',
  emoji: '🍇',
  gradient: 'bg-gradient-to-br from-[#8b3dff] to-[#ff3da6]',
  span: 'col-span-1 row-span-1'
}, {
  caption: 'פסיפלורה',
  emoji: '🍑',
  gradient: 'bg-gradient-to-br from-[#ff7a00] to-[#ff3da6]',
  span: 'col-span-2 row-span-1'
}];
const TESTIMONIALS = [{
  name: 'רוני כהן',
  text: 'המיצים הכי טעימים ששתיתי! פשוט התמכרתי.',
  emoji: '😍',
  color: 'bg-[#ffd23f]'
}, {
  name: 'דניאל לוי',
  text: 'שירות מדהים ומשלוח מהיר. ממליץ בחום!',
  emoji: '🚀',
  color: 'bg-[#aaff00]'
}, {
  name: 'מיכל שיר',
  text: "הבוקר שלי לא מתחיל בלי ג'אמפ. פצצת אנרגיה!",
  emoji: '⚡',
  color: 'bg-[#ff3da6]'
}];
export function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("יש! מצטרפים למשפחת ג'אמפ 🎉", {
      style: {
        background: '#aaff00',
        color: '#1a1424',
        border: 'none',
        fontWeight: 'bold',
        fontSize: '1.1rem',
        borderRadius: '1rem'
      }
    });
  };
  return <div className="min-h-screen bg-white overflow-hidden" data-id="element-4">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 p-4 md:p-6 pointer-events-none" data-id="element-5">
        <div className="max-w-7xl mx-auto bg-white/80 backdrop-blur-xl border-4 border-black rounded-[2rem] p-4 flex items-center justify-between pointer-events-auto shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]" data-id="element-6">
          <div className="flex items-center gap-2" data-id="element-7">
            <span className="font-display text-4xl font-black tracking-tighter text-[#ff3da6] -rotate-3" data-id="element-8">
              JUMP
            </span>
            <span className="text-3xl animate-bounce" data-id="element-9">🍊</span>
          </div>

          <div className="hidden md:flex items-center gap-8" data-id="element-10">
            {NAV_LINKS.map(link => <a key={link.name} href={link.href} className="font-bold text-lg hover:text-[#ff3da6] transition-colors" data-id="element-11">
                {link.name}
              </a>)}
          </div>

          <div className="hidden md:block" data-id="element-12">
            <motion.button whileHover={{
            scale: 1.05,
            rotate: -2
          }} whileTap={{
            scale: 0.95
          }} className="bg-[#aaff00] text-black font-display font-bold text-xl px-8 py-3 rounded-full border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:bg-[#ff7a00] transition-colors" data-id="element-13">
              הזמינו עכשיו
            </motion.button>
          </div>

          <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-14">
            {isMenuOpen ? <X size={32} data-id="element-15" /> : <Menu size={32} data-id="element-16" />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-17">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="fixed inset-0 z-40 bg-[#ff3da6] flex flex-col items-center justify-center gap-8" data-id="element-18">
            {NAV_LINKS.map(link => <a key={link.name} href={link.href} onClick={() => setIsMenuOpen(false)} className="font-display text-5xl font-black text-white hover:text-[#aaff00] transition-colors" data-id="element-19">
                {link.name}
              </a>)}
            <button className="bg-[#aaff00] text-black font-display font-bold text-3xl px-10 py-4 rounded-full border-4 border-black shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] mt-8" data-id="element-20">
              הזמינו עכשיו
            </button>
          </motion.div>}
      </AnimatePresence>

      {/* HERO */}
      <section className="relative min-h-screen pt-40 pb-20 px-4 flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#ff7a00] via-[#ff3da6] to-[#8b3dff]" data-id="element-21">
        {/* Animated Blobs */}
        <div className="absolute top-1/4 -right-20 w-96 h-96 bg-[#ffd23f] animate-blob mix-blend-multiply filter blur-2xl opacity-70" data-id="element-22"></div>
        <div className="absolute bottom-1/4 -left-20 w-96 h-96 bg-[#00d4ff] animate-blob mix-blend-multiply filter blur-2xl opacity-70" style={{
        animationDelay: '2s'
      }} data-id="element-23"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[40rem] bg-[#aaff00] animate-blob mix-blend-multiply filter blur-3xl opacity-50" style={{
        animationDelay: '4s'
      }} data-id="element-24"></div>

        {/* Floating Fruits */}
        <div className="absolute top-32 right-10 text-6xl animate-float" style={{
        animationDelay: '0s'
      }} data-id="element-25">
          🍓
        </div>
        <div className="absolute bottom-32 left-10 text-7xl animate-float" style={{
        animationDelay: '1s'
      }} data-id="element-26">
          🥝
        </div>
        <div className="absolute top-40 left-20 text-5xl animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-27">
          🍑
        </div>
        <div className="absolute bottom-40 right-20 text-6xl animate-float" style={{
        animationDelay: '3s'
      }} data-id="element-28">
          🍋
        </div>

        <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-29">
          <motion.h1 initial={{
          scale: 0.8,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          type: 'spring',
          bounce: 0.5,
          duration: 1
        }} className="font-display text-6xl md:text-8xl lg:text-9xl font-black text-white leading-tight mb-8 drop-shadow-[0_10px_0_rgba(0,0,0,0.2)]" data-id="element-30">
            מיץ שגורם לך <br data-id="element-31" />
            <span className="text-[#aaff00] inline-block hover:scale-110 transition-transform cursor-pointer" data-id="element-32">
              לקפוץ
            </span>{' '}
            <span className="text-[#ffd23f] inline-block hover:scale-110 transition-transform cursor-pointer" data-id="element-33">
              משמחה
            </span>
          </motion.h1>

          <motion.p initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="text-2xl md:text-3xl text-white font-bold mb-12 max-w-2xl mx-auto" data-id="element-34">
            100% פירות וירקות טריים, סחוטים בכבישה קרה. בלי סוכר, בלי שטויות. רק
            אנרגיה טהורה!
          </motion.p>

          <motion.button whileHover={{
          scale: 1.1,
          rotate: 3
        }} whileTap={{
          scale: 0.9
        }} className="bg-white text-[#ff3da6] font-display font-black text-3xl md:text-4xl px-12 py-6 rounded-full border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:bg-[#ffd23f] hover:text-black transition-colors" data-id="element-35">
            בואו נשתה! 🥤
          </motion.button>
        </div>

        {/* Wavy Divider Bottom */}
        <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-none" data-id="element-36">
          <svg className="relative block w-full h-[100px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-37">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,123.8,198.39,111.42,241.6,103.54,284.46,84.4,321.39,56.44Z" fill="#ffffff" data-id="element-38"></path>
          </svg>
        </div>
      </section>

      {/* FLAVORS */}
      <section id="menu" className="py-24 px-4 bg-white" data-id="element-39">
        <div className="max-w-7xl mx-auto" data-id="element-40">
          <div className="text-center mb-16" data-id="element-41">
            <h2 className="font-display text-5xl md:text-7xl font-black mb-6" data-id="element-42">
              הטעמים <span className="text-[#ff7a00]" data-id="element-43">המשוגעים</span> שלנו
            </h2>
            <p className="text-xl font-medium text-gray-600" data-id="element-44">
              כל בקבוק הוא מסיבה בפה
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-45">
            {FLAVORS.map((flavor, i) => <motion.div key={flavor.name} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1,
            type: 'spring',
            bounce: 0.4
          }} whileHover={{
            y: -15,
            rotate: i % 2 === 0 ? 2 : -2
          }} className={`${flavor.color} rounded-[3rem] p-8 border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] relative overflow-hidden group`} data-id="element-46">
                <div className="absolute -top-10 -right-10 text-9xl opacity-50 group-hover:scale-110 group-hover:rotate-12 transition-transform duration-500" data-id="element-47">
                  {flavor.emoji}
                </div>

                <div className="relative z-10" data-id="element-48">
                  <div className="text-6xl mb-6" data-id="element-49">{flavor.emoji}</div>
                  <h3 className="font-display text-4xl font-black text-black mb-2" data-id="element-50">
                    {flavor.name}
                  </h3>
                  <p className="text-black/80 font-bold text-lg mb-8 h-14" data-id="element-51">
                    {flavor.ingredients}
                  </p>

                  <div className="flex items-center justify-between" data-id="element-52">
                    <span className="font-display text-3xl font-black" data-id="element-53">
                      {flavor.price}
                    </span>
                    <button className="bg-white text-black font-bold px-6 py-3 rounded-full border-2 border-black hover:bg-black hover:text-white transition-colors" data-id="element-54">
                      הוסף לסל
                    </button>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="py-24 px-4 bg-[#f8f9fa] relative overflow-hidden" data-id="element-55">
        <div className="max-w-7xl mx-auto" data-id="element-56">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-57">
            {BENEFITS.map((benefit, i) => <motion.div key={benefit.title} initial={{
            scale: 0.8,
            opacity: 0
          }} whileInView={{
            scale: 1,
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1,
            type: 'spring'
          }} whileHover={{
            scale: 1.05
          }} className="bg-white rounded-[2rem] p-8 border-4 border-black shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] text-center flex flex-col items-center" data-id="element-58">
                <div className={`w-24 h-24 rounded-full ${benefit.bg} flex items-center justify-center mb-6`} data-id="element-59">
                  <benefit.icon size={48} className={benefit.color} data-id="element-60" />
                </div>
                <h3 className="font-display text-2xl font-black" data-id="element-61">
                  {benefit.title}
                </h3>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* SUBSCRIPTIONS */}
      <section id="subscriptions" className="py-24 px-4 bg-[#8b3dff] relative" data-id="element-62">
        {/* Wavy Divider Top */}
        <div className="absolute top-0 left-0 right-0 w-full overflow-hidden leading-none rotate-180" data-id="element-63">
          <svg className="relative block w-full h-[100px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-64">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,123.8,198.39,111.42,241.6,103.54,284.46,84.4,321.39,56.44Z" fill="#f8f9fa" data-id="element-65"></path>
          </svg>
        </div>

        <div className="max-w-7xl mx-auto pt-16" data-id="element-66">
          <div className="text-center mb-16" data-id="element-67">
            <h2 className="font-display text-5xl md:text-7xl font-black text-white mb-6" data-id="element-68">
              מנויים שווים
            </h2>
            <p className="text-xl font-bold text-white/80" data-id="element-69">
              אל תישארו צמאים לעולם
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center" data-id="element-70">
            {PLANS.map((plan, i) => <motion.div key={plan.name} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className={`${plan.color} rounded-[3rem] p-8 border-4 border-black shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] relative ${plan.popular ? 'md:-translate-y-8 md:scale-105 z-10' : ''}`} data-id="element-71">
                {plan.popular && <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-[#aaff00] text-black font-display font-black px-6 py-2 rounded-full border-4 border-black rotate-3" data-id="element-72">
                    הכי משתלם! 🔥
                  </div>}
                <h3 className="font-display text-4xl font-black mb-4" data-id="element-73">
                  {plan.name}
                </h3>
                <p className="text-xl font-bold mb-8" data-id="element-74">{plan.desc}</p>
                <div className="mb-8" data-id="element-75">
                  <span className="font-display text-6xl font-black" data-id="element-76">
                    {plan.price}
                  </span>
                  <span className="text-xl font-bold" data-id="element-77">/{plan.period}</span>
                </div>
                <button className="w-full bg-white text-black font-display font-black text-2xl py-4 rounded-full border-4 border-black hover:bg-black hover:text-white transition-colors" data-id="element-78">
                  בחרו מסלול
                </button>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* GALLERY */}
      <section className="py-24 px-4 bg-white overflow-hidden" data-id="element-79">
        <div className="max-w-7xl mx-auto" data-id="element-80">
          <div className="text-center mb-16" data-id="element-81">
            <h2 className="font-display text-5xl md:text-7xl font-black mb-6" data-id="element-82">
              גלריית <span className="text-[#00d4ff]" data-id="element-83">הצבעים</span>
            </h2>
            <p className="text-xl font-bold text-gray-600" data-id="element-84">
              צבעוני, עסיסי, ובלתי ניתן לעצירה
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[140px] md:auto-rows-[180px] gap-4" data-id="element-85">
            {GALLERY.map((item, i) => <motion.div key={item.caption} initial={{
            opacity: 0,
            scale: 0.85
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08,
            type: 'spring',
            bounce: 0.45
          }} whileHover={{
            scale: 1.03,
            rotate: i % 2 === 0 ? 1.5 : -1.5
          }} className={`${item.span} ${item.gradient} rounded-[2rem] border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] relative overflow-hidden group cursor-pointer`} data-id="element-86">
                <div className="absolute inset-0 flex items-center justify-center text-7xl md:text-8xl opacity-80 group-hover:scale-125 group-hover:rotate-12 transition-transform duration-500" data-id="element-87">
                  {item.emoji}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-black/0 group-hover:bg-black/30 transition-colors" data-id="element-88">
                  <span className="font-display text-lg md:text-xl font-black text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-[0_2px_0_rgba(0,0,0,0.4)]" data-id="element-89">
                    {item.caption}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-24 px-4 bg-white" data-id="element-90">
        <div className="max-w-7xl mx-auto" data-id="element-91">
          <h2 className="font-display text-5xl md:text-7xl font-black text-center mb-16" data-id="element-92">
            מה אומרים <span className="text-[#ff3da6]" data-id="element-93">עלינו</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-94">
            {TESTIMONIALS.map((test, i) => <motion.div key={test.name} initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} whileHover={{
            rotate: i % 2 === 0 ? 3 : -3
          }} className={`${test.color} rounded-[2rem] p-8 border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] transform ${i % 2 === 0 ? 'rotate-2' : '-rotate-2'}`} data-id="element-95">
                <div className="flex text-black mb-4" data-id="element-96">
                  {[...Array(5)].map((_, j) => <Star key={j} className="fill-current" size={24} data-id="element-97" />)}
                </div>
                <p className="text-2xl font-bold mb-6 leading-snug" data-id="element-98">
                  "{test.text}"
                </p>
                <div className="flex items-center gap-4" data-id="element-99">
                  <div className="w-12 h-12 bg-white rounded-full border-2 border-black flex items-center justify-center text-2xl" data-id="element-100">
                    {test.emoji}
                  </div>
                  <span className="font-display text-xl font-black" data-id="element-101">
                    {test.name}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* NEWSLETTER */}
      <section className="py-24 px-4 bg-[#ffd23f] relative overflow-hidden" data-id="element-102">
        <div className="max-w-4xl mx-auto bg-white rounded-[3rem] p-12 border-4 border-black shadow-[16px_16px_0px_0px_rgba(0,0,0,1)] text-center relative z-10" data-id="element-103">
          <div className="absolute -top-12 -right-12 text-8xl animate-bounce" data-id="element-104">
            💌
          </div>
          <h2 className="font-display text-4xl md:text-6xl font-black mb-6" data-id="element-105">
            הצטרפו למועדון שלנו!
          </h2>
          <p className="text-xl font-bold mb-8" data-id="element-106">
            קבלו עדכונים על טעמים חדשים, מבצעים והפתעות שוות.
          </p>

          <form onSubmit={handleSubscribe} className="flex flex-col md:flex-row gap-4 max-w-2xl mx-auto" data-id="element-107">
            <input type="email" placeholder="האימייל שלכם כאן..." required className="flex-1 bg-[#f8f9fa] border-4 border-black rounded-full px-8 py-4 text-xl font-bold focus:outline-none focus:border-[#ff3da6]" data-id="element-108" />
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} type="submit" className="bg-[#ff3da6] text-white font-display font-black text-2xl px-10 py-4 rounded-full border-4 border-black hover:bg-[#8b3dff] transition-colors" data-id="element-109">
              הרשמה
            </motion.button>
          </form>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-black text-white pt-20 pb-10 px-4 relative" data-id="element-110">
        {/* Wavy Divider Top */}
        <div className="absolute top-0 left-0 right-0 w-full overflow-hidden leading-none rotate-180" data-id="element-111">
          <svg className="relative block w-full h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-112">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,123.8,198.39,111.42,241.6,103.54,284.46,84.4,321.39,56.44Z" fill="#ffd23f" data-id="element-113"></path>
          </svg>
        </div>

        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-114">
          <div className="col-span-1 md:col-span-2" data-id="element-115">
            <div className="flex items-center gap-2 mb-6" data-id="element-116">
              <span className="font-display text-5xl font-black tracking-tighter text-[#aaff00]" data-id="element-117">
                JUMP
              </span>
              <span className="text-4xl" data-id="element-118">🍊</span>
            </div>
            <p className="text-xl font-bold text-white/80 max-w-md" data-id="element-119">
              אנחנו מאמינים שמיץ צריך להיות כיף, טעים, ובריא. בלי פשרות.
            </p>
          </div>

          <div data-id="element-120">
            <h4 className="font-display text-2xl font-black mb-6 text-[#00d4ff]" data-id="element-121">
              קישורים
            </h4>
            <ul className="space-y-4 font-bold text-lg" data-id="element-122">
              <li data-id="element-123">
                <a href="#menu" className="hover:text-[#ff3da6] transition-colors" data-id="element-124">
                  התפריט שלנו
                </a>
              </li>
              <li data-id="element-125">
                <a href="#subscriptions" className="hover:text-[#ff3da6] transition-colors" data-id="element-126">
                  מנויים
                </a>
              </li>
              <li data-id="element-127">
                <a href="#" className="hover:text-[#ff3da6] transition-colors" data-id="element-128">
                  שאלות נפוצות
                </a>
              </li>
              <li data-id="element-129">
                <a href="#" className="hover:text-[#ff3da6] transition-colors" data-id="element-130">
                  צור קשר
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-131">
            <h4 className="font-display text-2xl font-black mb-6 text-[#ff7a00]" data-id="element-132">
              עקבו אחרינו
            </h4>
            <div className="flex gap-4" data-id="element-133">
              <a href="#" className="w-12 h-12 bg-white text-black rounded-full flex items-center justify-center hover:bg-[#ff3da6] hover:text-white transition-colors border-2 border-transparent hover:border-white" data-id="element-134">
                <Instagram size={24} data-id="element-135" />
              </a>
              <a href="#" className="w-12 h-12 bg-white text-black rounded-full flex items-center justify-center hover:bg-[#00d4ff] hover:text-white transition-colors border-2 border-transparent hover:border-white" data-id="element-136">
                <Facebook size={24} data-id="element-137" />
              </a>
              <a href="#" className="w-12 h-12 bg-white text-black rounded-full flex items-center justify-center hover:bg-[#aaff00] hover:text-white transition-colors border-2 border-transparent hover:border-white" data-id="element-138">
                <Twitter size={24} data-id="element-139" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t-2 border-white/20 pt-8 text-center font-bold text-white/60" data-id="element-140">
          <p data-id="element-141">© 2026 JUMP. כל הזכויות שמורות. נוצר באהבה 💖</p>
        </div>
      </footer>
    </div>;
}